import { apiConfig } from "core-lib/config/config";
import { postMethod } from "core-lib/utils/apiV2";
import { getDefaultHeaders } from "core-lib/utils/network";

export const validatePromo = async (body) => {
  const url = `${apiConfig("promoNew", "v5")}/validate/`;
  const defaultHeaders = getDefaultHeaders({
    deviceId: true,
    coords: true,
    packageName: true,
    effectivePlatform: true,
  });
  const { response, error }: any = await postMethod({
    endPoint: url,
    body,
    headers: defaultHeaders,
  });

  if (response) return { response };
  else return { error };
};
